import './review-form.ajscss';

import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './review-form.html';

const MODULE_NAME = 'reviewForm';

class ReviewFormCtrl implements IComponentController {
  public name = MODULE_NAME;

  // binding
  public review: string;
  public eventReviewChange: Function;

  $onInit(): void {}

  onReviewChange({ comment }): void {
    this.review = comment;
    this.eventReviewChange({ $event: { review: this.review } });
  }
}

export class ReviewForm implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    review: '<',
    eventReviewChange: '&',
  };
  controller = [ReviewFormCtrl];
}

export default MODULE_NAME;
